export const tl = {
    "TRIGGER_LISTEN" : "Pakikinig para sa mga trigger",
    "ASSIST_EMPTY_MSG" : "Ang AI Agent ay nakikinig sa iyong pag-uusap at handang tumulong kapag na-trigger.",
    "MYBOT_TRIGGET_LISTEN" : "Walang aktibong My Bot na gawain sa kasalukuyan",
    "MYBOT_EMTPY_MSG" : "Upang simulan ang isang gawain sa My Bot, pumunta sa search tab at piliin ang \"Patakbuhin gamit ang mga input ng agent\" para sa nais mong gawain.",
    "PROACTIVE_MODE": "Proactive Mode",
    "SETTINGS": "Mga Setting",
    "HELP_AND_SUPPORT": "Tulong at Suporta",
    "HELP": "Tulong",
    "LANGUAGE": "Wika",
    "THEME": "Tema",
    "FILE_NAME":"Pangalan ng file",
    "AUTOMATIC": "Awtomatik",
    "AUTO_SCROLL_TOOLTIP":"Kinokontrol ang awtomatik na pag-scroll ng Assist Tab, Aking bot & Mga Nilalaman ng Transcript Tab",
    "DARK": "Madilim",
    "LIGHT": "Maliwanag",
    "THEME_DESC": "Gagamitin nito ang default na mode ng iyong system",
    "DOCUMENTATION": "Dokumentasyon",
    "DOC_DESC": "Tingnan ang aming mas detalyadong mga artikulo sa dokumentasyon.",
    "FAQ_U": "FAQ",
    "FAQ_DESC": "Tingnan ang mga madalas itanong tungkol sa AI Agent.",
    "KORE_ACADEMY": "Kore Academy",
    "KORE_ACA_DESC": "Matuto nang higit pa tungkol sa AI Agent sa pamamagitan ng mga kurso sa akademya.",
    "SEARCH": "Hanapin",
    "TAB_TEXT":"Walang tab na naka-enable! Mangyaring i-enable ang hindi bababa sa isang tab",
    "MY_BOT": "My Bot",
    "ASSIST": "Tulong",
    "TRANSCRIPT": "Transcript",
    "HISTORY" : "Kasaysayan",
    "STARTOVER" : "Simulan Muli",
    "TAP_SEARCH":"Tapikin para maghanap",
    "RESTART_INPUTS" : "Muling simulan gamit ang mga nakuhang input",
    "ASKCUSTOMER" : "Magtanong sa Customer",
    "TELLCUSTOMER" : "Sabihin sa Customer",
    "WELCOME_MSG" : "Mensahe ng Pagbati",
    "SEND" : "Ipadala",
    "SENT" : "Naipadala",
    "AWAITING" : "Naghihintay ng Tugon  |  Mag-type para magpatuloy",
    "OVERRIDE" : "Mag-type para magpatuloy",
    "OVERRIDE_FILE" : "I-attach ang File para magpatuloy",
    "ACCEPT_RESPONSE" : "Tanggapin ang Tugon",
    "AGENT_ENTERED" : "Agent ay Pumasok",
    "EXPECTED_FORMAT" : "Inaasahang Format", 
    "INPUT_VALUES" : "Mga Halaga ng Input", 
    "RESTART" : "Muling Simulan",
    "START_OVER" : "Simulan Muli",
    "RESTART_CAPTURE" : "Muling simulan gamit ang mga nakuhang input",
    "CANCEL" : "Kanselahin",
    "INTERRUPT_DIALOG" : "INTERRUPT na Dialog Task",
    "RUN" : "Patakbuhin",
    "RUN_AGENT" : "Patakbuhin gamit ang input ng Agent",
    "STEP" : "Hakbang",
    "DIALOG_TASK" : "Dialog Task",
    "FAQ" : "FAQ",
    "SNIPPET" : "Mga Sagot",
    "ARTICLE" : "Mga Pahina ng Web",
    "FILE" : "Mga File",
    "SUGGESTED" : "Iminungkahi",
    "ALL_DIALOG" : "Lahat ng Dialog Tasks",
    "DIALOG_TEXT" : "Dialog",
    "INTENT_IDENTIFIED" : "Utterance ng Customer",
    "NOT_WHAT_LOOKING" : "Maling Mungkahi?",
    "BOT" : "Bot", 
    "CUSTOMER" : "Customer",
    "YOU" : "Ikaw",
    "TERMINATE_CONV" : "Itigil ang Dialog Task",
    "TERMINATE_CONV_DESC" : "Sigurado ka bang gusto mong itigil ang dialog task? Hindi na makakagawa ng mga mungkahi ang AI Agent.",
    "YES_TERMINATE" : "Oo, Itigil",
    "NO_CANCEL" : "Hindi, Kanselahin",
    "OVERRIDE_CONTINUE" : "Magpatuloy gamit ang override mode",
    "SUMMARY_TEXT" : "Buod",
    "SUBMIT" : "Ipasa",
    "INTERRUPT_OCCURED" : "Nagkaroon ng Interruption",
    "IDENTIFIED_INTENT" : "Natukoy na Layunin",
    "INTERRUPT_DESC" : "Ang pagpapatakbo nito ay magtatapos sa iyong kasalukuyang Dialog Task.",
    "ACCEPT_RUN" : "Tanggapin at Patakbuhin",
    "RUN_LATER" : "Patakbuhin Mamaya",
    "KNOW_MORE" : "Alamin Pa",
    "MORE_TEXT" : "Higit Pa",
    "LESS_TEXT" : "Mas Kaunti",
    "VIEW_MORE" : "Tingnan Pa",
    "VIEW_LESS" : "Mas Kaunti",
    "SHOW_MORE_FAQ" : "Ipakita ang mas maraming FAQ",
    "SHOW_LESS_FAQ" : "Mas kaunting FAQ",
    "SHOW_MORE_ARTICLE" : "Ipakita ang mas maraming mga pahina ng web",
    "SHOW_LESS_ARTICLE" : "Mas kaunting mga pahina ng web",
    "SHOW_MORE_SNIPPET" : "Ipakita ang mas maraming Sagot",
    "SHOW_LESS_SNIPPET" : "Mas kaunting mga Sagot",
    "SHOW_MORE_FILES" : "Ipakita ang mas maraming mga File",
    "SHOW_LESS_FILES" : "Mas kaunting mga File",
    "VIEW_ALL_DIALOG" : "Tingnan ang lahat ng Dialog",
    "VIEW_FEW_DIALOG" : "Tingnan ang ilan sa Dialog",
    "HELP_FULL" : "Nakatulong ba?",
    "THANKYOU" : "Salamat!",
    "EXPAND_MORE" : "Palawakin / Higit Pa",
    "CLOSE_TEXT" : "Isara",
    "STARTED" : "Nagsimula",
    "ENDED" : "Natapos",
    "VIEW_FULL_ARTICLE" : "Tingnan ang buong pahina ng web",
    "VIEW_FULL_FILE" : "Tingnan ang buong file",
    "COPIED" : "Nakopya",
    "SENTI_ANALY" : "Pagsusuri ng Sentimyento",
    "WRONG_SUGGESTION" : "Maling mungkahi",
    "INCORRECT_INTENT" : "Maling layunin",
    "ACCIDENTAL_CLICK" : "Aksidenteng pag-click",
    "TIME_TAKING" : "Matagal",
    "OTHER" : "Iba",
    "PLAYBOOK_EMPTY_MSG" : "Piliin ang Playbook",
    "PLAYBOOK_EMPTY_DESC" : "Hindi ma-load ng AI Agent ang playbook dahil lahat ng available na playbooks ay dynamic. I-click ang 'Piliin ang Playbook' upang makapunta sa playbook",
    "STAGE" : "Yugto", 
    "PROCEED_TO_CLOSE" : "Magpatuloy upang isara",
    "RECOMENDED_PLAYBOOK" : "IMINUNGKAHING PLAYBOOK",
    "PRIMARY_SCRIPTS" : "PANGUNAHING SCRIPT",
    "DYNAMIC_SCRIPTS" : "DYNAMIC SCRIPT",
    "RESUME" : "Ipagpatuloy",
    "ENABLE_CLOSE" : "I-click ang magpatuloy upang isara upang paganahin ang yugto ng Pagsasara",
    "LIST_VIEW" : "Tingnan ang Listahan",
    "TERMINATE" : "Itigil",
    "MINIMIZE" : "Paliitin",
    "MAXIMIZE" : "Palakihin",
    "NO_SEARCH_RESULT" : "Walang nakitang resulta sa paghahanap",
    "SENTIMENT_AWAITING" : "Naghihintay para sa sentimyento",
    "POSITIVE" : "Positibo",
    "NEGATIVE" : "Negatibo",
    "ASSOCIATED_WORK_NOTES": "Nakaraang Tala ng Resolusyon",
    "AGENT_JOINED_CONV": "Sumali ang Agent sa pag-uusap",
    "AUTOSCROLL_ASSIST" : "Auto-Scroll ng nilalaman ng Tab ng Tulong",
    "FILE_SIZE_MSG" : "Ang laki ng file ay dapat nasa loob ng 25MB. Pakiulit.",
    "OVERRIDE_BTN" : "Palitan",
    "CHOOSE_FILE" : "Pumili ng File",
    "PLAYBOOK": "Playbook",
    "SUMMARY_ERROR_TEXT" : "Paumanhin, ngunit nagkaroon ng problema sa paggawa ng buod para sa pag-uusap na ito. Mangyaring lumikha ng sarili mong buod",
    "ASK_A_QUESTION": "Magtanong",
    "COPY" : "Kopyahin",
    "TELL_US_MORE": "Sabihin sa amin nang higit pa...",
    "THANKS_FEEDBACK": "Salamat sa iyong feedback",
    "SOMETHING_WRONG": "Mayroong isang problema",
    "CLICK_ERROR_DETAILS": "I-click upang tingnan ang mga detalye ng error",
    "NO_ACTIVE_PLAYBOOK": "Walang aktibong playbook",
    "REPHRASE_QUESTION": "Maaari mo bang muling ipahayag ang iyong tanong o magtanong ng iba?",
    "VIEW_FULL_ARTICLE_2": "Tingnan ang buong artikulo",
    "VIEW_FULL_FILE_2": "Tingnan ang buong file",
    "INTERNAL_INFO": "Panloob na impormasyon",
    "SOURCES": "Mga pinagmulan",
    "CONVERSATION_SUMMARY": "Buod ng pag-uusap",
    "WAITING": "Naghihintay",
    "WIDGET_DISABLED": "Naka-disable ang widget",
    "AI_SETTINGS_DISABLED": "Naka-disable ang mga setting ng AI! Mangyaring makipag-ugnayan sa administrador ng AI",
    "SERVER_CONNECTION_ERROR": "Nagkaroon ng error habang kumokonekta sa server",
    "VIEW": "Tingnan",
    "ATTACHMENT_INPUT": "Input ng kalakip",
    "TYPE_SUMMARY": "I-type ang buod",
    "BY":"Sa pamamagitan ng",
    GENERATE_SUMMARY: "Bumuo ng buod",
    PREV_SUMMARIES: "Naunang Nabuo na mga Buod",
    DIALOG_WORKFLOWS: "Mga Dialog Workflow",
    SHOW_ALL_DIALOG: "Ipakita ang lahat ng Dialog Task",
    SHOW_ALL_DIALOGS: "Ipakita ang Lahat ng mga Dialog",
    CUSTOM_TAB: "Custom Tab",
    AGENT_INPUT: "Input ng Agent",
    CUSTOM_EMPTY_MSG: "Walang aktibong workflow sa kasalukuyan",
    CUSTOM_TAB_DESC: "Upang simulan ang isang workflow, patakbuhin ang isang item mula sa listahan na nakalista sa ibaba ng screen.",
    SUBMIT_OVERALL_FEEDBACK: "Ipadala ang lahat ng feedback",
    FEEDBACK_POPUP_SUBTITLE: "Feedback tungkol sa widget at kanyang mga tampok",
    FEEDBACK_SATISFIED: "Satisfy na",
    FEEDBACK_UNSATISFIED: "Hindi Satisfy na",
    FEEDBACK_PROVIDE_REASONS: "Magbigay ng higit pang impormasyon...",
    FEEDBACK_TITLE: "Mga Feedback",
    "AGENTIC_THINKING" : "Nag-iisip",
    "AGENTIC_AGENT_TITLE" : "Ahente",
    "AGENTIC_COPILOT_MODE_TITLE" : "Agentic Copilot Mode",
    "AGENTIC_SENDING_MESSAGE" : "Nagpapadala...",
    "AGENTIC_COPILOT_DESC" : "Ang Agentic Copilot ay aktibong nakikinig sa iyong pag-uusap at handang tumulong nang awtomatiko",
    "AGENTIC_SEARCH_RESULTS" : "Mga Resulta ng Ahente",
    "PAUSE_AUTO_SEND" : "I-pause ang Auto Send",
    "PAUSE_AGENTIC" : "I-pause ang Agentic",
    "RESUME_AGENTIC" : "I-resume ang Agentic",
    "RESUME_AUTO_SEND" : "I-resume ang Auto Send"
}